export class ForwardMessage {
    VehicleId: number;
    Inspection: boolean;
    RemainingKm?: string;
    RemainingTime?: string;
    Subject?: string;
    Text?: string;
}
